import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {H2hFactory} from "./h2h-factory";
import {H2hRepository} from "./h2h-repository";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";

export class H2hDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, H2hRepository, H2hFactory, DomainRequestManager];
}
